// extracted by mini-css-extract-plugin
export default {"wrapper":"SomethingGoingWrong_wrapper__sc53s","msg":"SomethingGoingWrong_msg__LgXRp","row":"SomethingGoingWrong_row__Hphsy","icon":"SomethingGoingWrong_icon__CoZlk"};